import { PageWrapTemplate } from '../../componentsF/PageTemplateF.jsx'
import '../../componentsF/xsiteBaitEmbedF.mts'
// use-new-run-test
import { CenterSpinnerFull } from '../../componentsF/CustomSiteF/CustomSiteWrapperF.jsx'
import { Ptext } from '../../componentsF/Chakra3F/ChakraF.jsx'
import { SsidWrapper } from '../../componentsF/SessIdWrapF.jsx'
import { PubEnvWrapper } from '../../componentsF/PubEnvWrapF.jsx'
import { PtSiteWrap } from '../../componentsF/PtSiteWrapF.jsx'
import { UserAuthWrapper } from '../../componentsF/UserAuthWrapperF.jsx'
import { CheckEmailTokenWrapper } from '../componentsF/CheckEmailTokenWrapperAI.jsx'
import UserAuthQuery from '../componentsF/CustomSiteF/GetGameUserFromUserTokenQuery.gql'

const App = ({Component, pageProps}) => {
  const value = {
    LoadingComp: CenterSpinnerFull,
    UserAuthQuery,
    fmtSiteError: ({error}) => <Ptext {...{fontSize: '3xl', textAlign: 'center', my: 20}}>
      {error?.message}{error?.graphQLErrors?.[0]?.extensions?.gqErrHelpedByReload !== false && <><br />Please try refreshing this page</>}
    </Ptext>,
  }
  return <PtSiteWrap {...{value}}>
    <PageWrapTemplate {...{initialColorMode: 'dark'}}>
      <UserAuthWrapper>
        <CheckEmailTokenWrapper>
          <SsidWrapper>
            <PubEnvWrapper {...{isQuiet: true}}>
              <Component {...pageProps} />
            </PubEnvWrapper>
          </SsidWrapper>
        </CheckEmailTokenWrapper>
      </UserAuthWrapper>
    </PageWrapTemplate>
  </PtSiteWrap>
}
export default App
